import { MenuItem, TextField } from "@material-ui/core";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showAlertSnackbar } from "../../../../reducers/uiSlice";
import UniDialog from "../../../Common/UniDialog";

function ExceptionDialog(props){
    const {exceptions, open, onClose, onFinish} = props;
    const dispatch = useDispatch();
    const {t} = useTranslation('editOrder');

    const [exceptionId, setExceptionId] = useState(0)

    return (
        <UniDialog
            title={t('dialog:select_exception_title')}
            maxWidth='xs'
            fullWidth
            open={open}
            onClose={()=>{
                onClose()
                setExceptionId(0)
            }}
            autoClose={false}
            onFinish={()=>submit()}
            contentStyle={{overflow: 'hidden'}}
        >
            <TextField
                select
                label={t("select_exception")}
                fullWidth
                variant="outlined"
                value={exceptionId}
                onChange={(event)=>setExceptionId(event.target.value)}
            >
                <MenuItem value={0}>
                    No Exception
                </MenuItem>
                {exceptions.map((exception) => (
                    <MenuItem key={exception.id} value={exception.id}>
                        {exception.en_message}
                    </MenuItem>
                ))}
            </TextField>
        </UniDialog>
    )

    function submit(){
        let result = validateValue(exceptionId)
        if(result === null){
            return
        }
        onFinish(result)
        onClose()
    }

    function validateValue(value){
        if(value === ""){
            dispatch(showAlertSnackbar({
                title: t('dialog:select_exception_title'), 
                message: t('dialog:validation_exception_empty')}
            ))
            return null
        }
        return value
    }
}

export default ExceptionDialog